/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const anchorTokens = {
  CoreFontFamily: '"Inter var", "fallback for Inter", sans-serif',
  CoreShadowFocus: '0px 0px 9px 0px #285da3',
  CoreOutlineOffset: '2px',
  CoreOutlineStroke: '2px solid',
  CoreOutlineColor: '#285da3',
  InverseTextColorInitial: '#8babd6',
  InverseTextColorActive: '#2c67b5',
  UnderlineTextColorInitial: '#1c2222',
  UnderlineTextColorHover: '#285da3',
  UnderlineTextColorActive: '#1a3e6d',
  UnderlineTextColorDisabled: '#a7aaaa',
  UnderlineTextDecorationDefault: 'underline',
  DropdownTextColorInitial: '#1c2222',
  DropdownTextColorHover: '#285da3',
  DropdownTextDecorationDefault: 'none',
  IconSpacing: '4px',
  BackwardIcon: '←',
  ForwardIcon: '→',
  NewTabIcon: '↗',
  DownloadIcon: '↓',
} as const;
